export default {
	操作成功: 'Done',
	操作失败: 'Operation failed',
	产品: 'Products',
	当余额不足时使用信用卡自动续费: 'Use credit card when balance is insufficient',
	订单: 'Orders',
	订单自动续费: 'Order auto-renewal',
	概览: 'Overview',
	个: '',
	更换: 'Change',
	获取全部: 'Show all',
	解除自动扣款: 'Cancel auto-pay',
	确认解除自动扣款吗: 'Cancel auto-pay for this card?',
	使用信用卡: 'Use card',
	使用账户余额: 'Use balance',
	首选信用卡: 'Preferred card',
	搜索订单号或IP: 'Search order no. or IP',
	未设置: 'Not set',
	下次续费: 'Next renewal',
	下次续费日期: 'Next renewal date',
	下次支付日期: 'Next payment',
	续费订单: 'Renewal Orders',
	续费记录: 'Records',
	账单周期: 'Billing period',
	扣款方式: 'Method',
	失败原因: 'Reason',
	续费日历: 'Renewal Calendar',
	选择信用卡: 'Select card',
	优先使用可用余额进行自动续费: 'Use available balance first for auto-renewal',
	暂无订单: 'No orders',
	账户余额: 'Balance',
	自动续费: 'Auto-renewal',
	自动续费费用: 'Auto-renewal spent',
	自动续费服务: 'Auto-renewal services',
	自动续费设置: 'Auto-renewal settings',
	自动续费说明:
		'A bill is generated 3 days before an order expires. Orders with auto-renewal enabled will attempt auto-payment, using your account balance and/or saved card per your settings — in order, or either one alone!',
}
